const referralCredits = "$30";
const blogCategories = [
  "Due Diligence Reports",
  "Risks",
  "Cross Border Trade",
  "Emerging Markets",
  "Currency and Settlement",
  "Alternatives",
  "Competitors"
];
const prodCDN = "https://static.credencedata.com/images/";
const stagingCDN = "https://static.credencedata.com/images_stg/";
const translationsProdCdn = "https://static.credencedata.com/locales/";
const translationsStgCdn = "https://static.credencedata.com/locales_stg/";
const reCaptchaKey = "6Ldwj_cpAAAAAMFNhKnnTgLeT7yboKC_Nv8zZ0cx";
const reportData = [
  {
    id: 1,
    name: "Fontana Finanziaria S.P.A.",
    country: "Italy",
    type: "FRESH",
    hashedOrderId: "MDE30NG9",
    devHashedOrderId:"MDE67EGK",
    stagingHashedOrderId:"MDEHT1Q5"
  },
  {
    id: 2,
    name: "ITOCHU SINGAPORE PTE LTD",
    country: "Singapore",
    type: "FRESH",
    hashedOrderId: "MDE30NKM",
    devHashedOrderId:"MDE7F881",
    stagingHashedOrderId:"MDEHRNJO"

  },
  {
    id: 3,
    name: "CEMCOA LIMITED",
    country: "Hong Kong",
    type: "FRESH",
    hashedOrderId: "MDE4AZ40",
    devHashedOrderId:"MDE67EDD",
    stagingHashedOrderId:"MDEHT1RW"

  },
  {
    id: 4,
    name: "Aditya Birla Fashion and Retail Limited",
    country: "India",
    type: "FRESH",
    hashedOrderId: "MBD49QTU",
    devHashedOrderId:"MDE7G4K1",
    stagingHashedOrderId:"MDEHT1O5"

  },
  {
    id: 5,
    name: "PDS FASHION USA LIMITED",
    country: "Hong Kong",
    type: "FRESH",
    hashedOrderId: "MDE30NDU",
    devHashedOrderId:"MDE4F4XR",
    stagingHashedOrderId:"MDEP3EPA"

  },
];

export default {
  reportData,
  referralCredits,
  blogCategories,
  prodCDN,
  stagingCDN,
  translationsProdCdn,
  translationsStgCdn,
  reCaptchaKey
};
